<template>
  <div id="s4s" class="scroll-page" style="position: relative;">
    <div style="background:#f8f8f8">
      <swiper-ad :list="bannerList" v-if="!advertisingShow"/>
      <div class="s4s-page">

        <!-- 爱车列表为空/未登录 start -->
        <!-- <div style="margin: 0 15px;"> -->
        <div v-if="carList.length == 0" class="s4s-car-info" style="margin: 10rpx 15rpx;">

          <div v-if="!manual" class="ai_recognition">
            <div class="ai_content" style="margin: 10px 15px ">
              <div class="s4s-title s4s-form-title">
                <div style="flex:1;line-height: 60rpx;">添加车辆查违章</div>
                <div class="s4s-title-icon">快速查询</div>
                <div class="s4s-title-icon1" v-if="['cmbchange','cmbapp'].indexOf(advertisingShow.channel) == -1">轻松代办
                </div>
              </div>
              <div style="width: 100%;margin-top:10px;" @click="uploadImage">
                <img src="https://mys4s.cn/h5/img_vio/search_ai.png" class="ai_img"/>
              </div>

            </div>

            <div style="margin: 10px 15px;background: #f0f">
              <button class="s4s-btn" @click="uploadImage"
                      :style="{backgroundImage:advertisingShow.backgroundImage,opacity:opacity}" :disabled="disabled">
                上传行驶证查询违章
              </button>
            </div>
            <div @click="handler"
                 style="color: #9C9EA8;font-size: 14px;text-align: center;margin-top: 16px;margin-bottom: 16px;">手动输入
            </div>
          </div>


        </div>

        <div v-if="manual" style="margin: 10px 15px">
          <div class="s4s-form-body">
            <div class="s4s-title s4s-form-title">
              <div style="display:flex;line-height: 30px;width:50%;">添加车辆查违章</div>
              <div style="display:flex;align-item:center;width:50%;justify-content: center;">
                <div class="s4s-title-icon">快速查询</div>
                <div class="s4s-title-icon1" v-if="['cmbchange','cmbapp'].indexOf(advertisingShow.channel) == -1">轻松代办
                </div>
              </div>
            </div>
            <div class="s4s-uplaod">
              <div class="s4s-uplaod-content" @click="uploadImage">
                <img class="s4s-uplaod-pic" src="../assets/icon/uploadPic.png"/>
                <span class="white">扫描行驶证</span>
              </div>

            </div>
            <div
                style="display:block;text-align:center;color: #BAC0C6;font-size:14px;margin-top:8px;margin-bottom: 10px">
              上传或拍摄行驶证照片，自动录入信息
            </div>
            <div class="s4s-group1" style="font-size:14px">
              <span class="s4s-group-tit">车辆类型</span>
              <span class="s4s-group-txt" @click="selectCarType" style="text-align: right">
            {{ carType.value }}
            <img src="../assets/icon/right-icon.png" class="s4s-arr-bottom1"/>
          </span>
            </div>
            <div :class="isCarnoTrue ? 's4s-group1' : 's4s-group1 s4s-group-error'">
              <span class="s4s-group-tit">车牌号码</span>
              <div style="display: flex;align-items:center;">
                <div class="s4s-sel-provice" style="float: left;">
                  <span @click="selectProvice">{{ provice }}</span>
                  <div class="triangle-button"></div>
                </div>
                <input @focus="showProvice = false" type="span" bindinput="bindNoInput"
                       name="carno" maxlength="7" v-model="carno" placeholder="请输入车牌号码"/>
              </div>
            </div>
            <!-- <div v-if="vinLength > 0" :class="isVinTrue ? 's4s-group1' : 's4s-group1 s4s-group-error'" > -->
            <div :class="isVinTrue ? 's4s-group1' : 's4s-group1 s4s-group-error'">
              <div class="s4s-group-tit">车架号码
                <span class="s4s-help"
                      @click="showImage('https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/img/classNo.png')"></span>
              </div>
              <input
                  type="text"
                  @focus="showProvice = false" maxlength="17"
                  bindinput="bindVinInput" name="vin" v-model="vin"
                  :placeholder="vinPlaceholder"/>

            </div>
            <!-- <div v-if="engineNoLength > 0"
              :class="isEngineTrue ? 's4s-group1' : 's4s-group1 s4s-group-error'"
            > -->
            <div :class="isEngineTrue ? 's4s-group1' : 's4s-group1 s4s-group-error'">
              <div class="s4s-group-tit">发动机号
                <span class="s4s-help"
                      @click="showImage('https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/img/engine.png')"></span>
              </div>
              <input type="text" minlength="6" maxlength="16"
                     name="engion" @focus="showProvice = false"
                     v-model="engion" :placeholder="enginePlaceholder"/>

            </div>

            <div :class="isEngineTrue ? 's4s-group1' : 's4s-group1 s4s-group-error'">
              <div class="s4s-group-tit">注册日期</div>
              <van-button @click="dataChoose" style="border: none;padding-left:0;padding-right:0;color: #9c9ea8"
                          :class="dataChange=='请选择日期' ? 'choose' : 'data'">{{ dataChange ? dataChange : '请选择日期' }}
                <img src="../assets/icon/right-icon.png" class="s4s-arr-bottom1"/>
              </van-button>
            </div>
          </div>
          <div v-if="error" class="s4s-error" style="margin-left: 15px;">{{ error }}</div>
          <div style="padding:0px 15px;overflow:hidden;">
            <button class="s4s-btn" @click="formSubmit"
                    :style="{backgroundImage:advertisingShow.backgroundImage,opacity:opacity}" :disabled="disabled">
              查询违章
            </button>
          </div>
        </div>
        <!-- 爱车列表为空/未登录 end -->
        <!-- 有爱车列表 start -->
        <div v-if="carList.length > 0" style="margin: 10rpx 15rpx;">
          <!-- 有爱车列表 轮播 start -->
          <Swiper :list="carList" @on-swiper-change="onSwiperChange"
                  :illegal="illegal" @on-swiper-add="onSwiperAdd"/>
          <!-- 有爱车列表 轮播 end -->
          <div class="s4s-illegal-item" v-for="(list, index) in records" :key="index" style="margin: 0 15px">
            <div class="s4s-illegal-list-body" style="padding-bottom: 16px;" @click="showDetail(list)">
              <div class="s4s-illegal-bd">
                <div class="s4s-illegal-bd-number">
                  <div class="s4s-origin">扣
                    <span style="color:#FFAF30;margin:0 3px;">{{ list.Point || 0 }}</span>分
                  </div>
                  <div class="s4s-origin">罚款
                    <span style="color:#FFAF30; margin:0 3px;">
                  {{ list.Fine || 0 }}
                </span>元 <span class="cant-btn" v-if="list.ProcessStatus != 1">
                  暂不支持处理</span>
                  </div>
                </div>
                <div class="s4s-illegal-bd-txt" style="width: 60%;">{{ list.Reason || '未知' }}</div>
                <div class="s4s-illegal-time">{{ list.OccTime || '-' }}</div>
              </div>
              <span v-if="list.ProcessStatus == 1 && ['cmbchange','cmbapp'].indexOf(advertisingShow.channel) == -1"
                    class="s4s-illegal-btn" @click.stop="gotoPay(list)"
                    :style="{backgroundImage:advertisingShow.backgroundImage}">
              立即办理
          </span>
            </div>
          </div>
          <div v-if="!records.length&&current!=carList.length">
            <div class="s4s-illegal-empty flex ">
              <img src="../assets/icon/illempty.png" style="width:20px;margin-right:10px;"/>
              暂无未完成交通违法
            </div>
          </div>
          <div v-if="(!records.length&&current!=carList.length)&& illegalError" class="illegal-error less-grey">
            您的车辆信息可能有误，请<span class="blue" @click="editcar(carList[current])">点击此处</span>编辑车辆信息，随时查看您的违章信息。
          </div>
          <div v-if="records.length == 0" class="s4s-illegal-empty" style="margin:10px 0;">
            <button size="mini" type="default" class="ticket-btn1" @click="gotoTicket">我有处罚决定书
              <img src="../assets/icon/right_arr.png" mode="aspectFit" class="s4s-right-arr"/>
            </button>
          </div>
          <div v-if="showSelectedItem" class="s4s-selected">
            <div class="s4s-mask" @click="hideDetailm"></div>
            <div class="s4s-selected-container">
              <div class="s4s-illegal-bd" style="width:auto;padding:15px 15px 30px;">
                <div class="s4s-illegal-hd">
                  <img class="s4s-illegal-icon" src="../assets/icon/loc.png"/>
                  <span class="s4s-illegal-addr">{{ selectedItem.Address || '未知' }}</span>
                </div>
                <div class="s4s-illegal-bd-number" style="margin:20px 0 15px;">
                  <div class="s4s-origin">
                    <span style="margin-right: 10px;">
                      扣<span style="color:#FFAF30;margin:0 3px;">{{ selectedItem.Point || 0 }}</span>分
                      </span> 罚款
                    <span style="color:#FFAF30;margin:0 3px;">{{ selectedItem.Fine || 0 }}</span>元
                    <span class="cant-btn" v-if="selectedItem.ProcessStatus != 1">暂不支持处理</span>
                  </div>
                </div>
                <div class="s4s-illegal-bd-txt">{{ selectedItem.Reason || '未知' }}</div>
                <div class="s4s-illegal-time">{{ selectedItem.OccTime || '' }}</div>
              </div>
              <div class="s4s-selected-btn-container">
                <div class="s4s-selected-btn" @click="hideDetailm">
                  关闭
                </div>
                <div
                    v-if="selectedItem.ProcessStatus == 1 && ['cmbchange','cmbapp'].indexOf(advertisingShow.channel) == -1"
                    class="s4s-selected-btn" @click="gotoPay(selectedItem)">
                  立即办理
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="s4s-copyright">
          <div style="text-align: center">本服务由 <span class="blue" @click="gotoMys4s">齐车大圣</span> 提供，客服电话：
            <a class="s4s-copyright-phone" href="tel://0571-26281166">0571-26281166</a>
          </div>
        </div>
        <!-- 有爱车列表 end -->
        <!-- 验证码 start -->
        <div v-if="showCaptcha" class="captcha">
          <div class="s4s-mask" @click="showCaptcha = false"/>
          <div class="captcha-container">
            <div class="captcha-title">请输入验证码</div>
            <img
                :src="captchUrl"
                style="width: 80%"
                @click="getCaptcha"/>
            <div
                class="captcha-change"
                @click="getCaptcha">看不清？换一张
            </div>
            <div class="captcha-input-container" bindtap="foucsShowCaptcha">
              <div v-for="item in captchValue"
                   :key="item.id"
                   class="captcha-input"
              >
                {{ item || '' }}
              </div>
            </div>
            <div class="captcha-keyboard">
              <div class="captcha-key-list" v-for="item in captchKeyArray" :key="item.id">
                <button v-for="ele in item" :key="ele"
                        class="captcha-key"
                        @click="onInputCaptcha(ele)">
                  {{ ele }}
                </button>
              </div>
              <div class="captcha-key-list">
                <button class="captcha-key">

                </button>
                <button class="captcha-key" @click="onInputCaptcha('0')">
                  0
                </button>
                <button class="captcha-key" @click="onInputCaptcha('←')">
                  ←
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 资讯 -->
      <a ref="movecar" href="https://mys4s.cn/static/nc/h5/index.html"></a>
      <!-- <a ref="movecar"  href="https://detail.m.tmall.com/item.htm?spm=a220m.1000858.1000725.1.67065fe1cQDg8v&id=568820639768&areaId=330100&user_id=3854958416&cat_id=2&is_b=1&rn=ef6767ee33437d5347ae5fc16b4e6910"></a> -->
      <a ref="baiduyqh"
         href="https://jin.baidu.com/mkt/cloan/guide?code=0122huoke01&channel=JXJhuoke&spot=qichedasheng-201808219"></a>
      <div v-if="!advertisingShow" style="position:relative">
        <div
            v-if="data.length"
            class="s4s-ad">
          <div class="s4s-ad-header">
            <div class="s4s-ad-line"/>
            <div class="s4s-ad-header-content">猜你想看</div>
            <div class="s4s-ad-line"/>
          </div>
          <div class="s4s-ad-list">
            <div v-for="(item,index) in data" :key="item.id||item.title">
              <div class="s4s-ad-other" @click="gotoMovecar" v-if="parseInt(index % 10)===2" :key="index+'movecar_ad'">
                <img src="https://mys4s.cn/h5/img_vio/movecar_ad.jpg"/>
              </div>
              <div class="s4s-ad-other" @click="gotoYQH" v-if="parseInt(index % 10)===3" :key="index+'baiduyqh'">
                <img src="https://mys4s.cn/h5/img_vio/baidu_yqh.png"/>
              </div>

              <div class="s4s-ad-item" @click="gotoNews(item)">

                <div style="width:100%">
                  <div v-if="item.cover_url1 || item.cover_url2 || item.cover_url3">
                    <h4 class="s4s-ad-title">{{ item.title }}</h4>
                    <div
                        v-if="item.cover_url1 && item.cover_url2 && item.cover_url3 && (item.cover_url1!=item.cover_url2 && item.cover_url1!=item.cover_url3 && item.cover_url2!=item.cover_url3)"
                        class="s4s-ad-images">
                      <img :src='item.cover_url1' class="s4s-ad-small-image"/>
                      <img :src='item.cover_url2' class="s4s-ad-small-image"/>
                      <img :src='item.cover_url3' class="s4s-ad-small-image"/>
                    </div>
                    <div v-else class="s4s-ad-image-container">
                      <img :src="item.cover_url1 ||item.cover_url2 || item.cover_url3 " class="s4s-ad-image"/>
                    </div>

                  </div>

                </div>
                <div class="s4s-ad-content">
                  <div class="s4s-ad-time less-grey flex space-between">
                    <div class="flex flex-center" v-if="item.Type===1">
                  <span class="s4s-ad-look flex" style="margin-right:18px">
                    <img src="../assets/icon/eye.png"
                         style="margin-right:4px;vertical-align: middle;height:10px;">浏览{{ item.show_num }}
                  </span>
                      <span class="s4s-ad-look flex">
                    <img src="../assets/icon/like.png"
                         style="margin-right:4px;vertical-align: middle;height:12px;">点赞{{ item.like_num || 0 }}
                  </span>
                    </div>
                    {{ item.last_modify_time && item.last_modify_time.substring(0, 10) }}
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div v-if="loading" class="s4s-loading-more">
            正在加载...
          </div>
          <div v-else class="s4s-loading-more">
            上拉加载更多
          </div>
        </div>

        <!-- </div> -->
        <!-- 资讯 end -->

        <div class="s4s-mask" @click="hideImage" v-if="helpImageSrc">
          <img :src="helpImageSrc" class="s4s-mask-image"/>
        </div>

      </div>
      <!-- 选择省份键盘 start -->
      <Provice :show="showProvice"
               @on-status-change="onProviceStatusChange"
               @on-result-change="onProviceResultChange"/>
      <!-- 选择省份键盘 end -->
      <!-- 车辆类型选择器 start -->
      <awesome-picker
          ref="picker"
          :type="picker.type"
          :data="picker.data"
          :anchor="picker.anchor"
          :textTitle="picker.textTitle"
          :textConfirm="picker.textConfirm"
          :textCancel="picker.textCancel"
          :swipeTime="picker.swipeTime"
          :colorTitle="picker.colorTitle"
          :colorConfirm="picker.colorConfirm"
          :colorCancel="picker.colorCancel"
          @cancel="handlePickerCancel"
          @confirm="handlePickerConfirm">
      </awesome-picker>
      <!-- 车辆类型选择器 end -->
      <van-popup v-model="showPop" position="bottom">
        <van-datetime-picker v-model="currentDate" type="date" @confirm="confirms" @cancel="cancels"
                             :min-date="minDate"/>
      </van-popup>
    </div>
    <!-- 拍照上传start -->
    <input
        ref="file"
        type="file"
        accept="image/*"
        multiple="multiple"
        style="display: none;"
        @change="fileChanged($event)"
    >
    <canvas id="canvas" style="display: none" />
    <!-- 拍照上传end -->
  </div>
</template>
<script>
// @ is an alias to /src
import Swiper from '@/components/Swiper.vue';
import Provice from '@/components/Provice.vue';
import SwiperAd from '@/components/SwiperAd.vue';
import advertisingShow from './../utils/advertising';
import jsfeat from '@/utils/jsfeat-min.js';
import { DatetimePicker, Popup, Button } from 'vant';
import photoScan from '@/utils/photoScan';

const rectIndex = 0;
const rectHeight = 0;
const animationId = null;
let photoAnimate = null;

export default {
  name: 'illegal',
  components: {
    Swiper,
    Provice,
    SwiperAd,
    DatetimePicker,
    Popup,
    Button,
  },
  data() {
    return {
      jsfeat,
      minDate: new Date(2000, 1, 1),
      screen: window.screen,
      canvasAnimation: false,
      canvasImgWidth: window.screen.availWidth,
      canvasImgHeight: window.screen.availHeight,
      imgTop: 0,
      rectIndex: 0,
      rectHeight: 150000,
      animationId: null,
      showPop: false,
      currentDate: new Date(),
      dataChange: '请选择日期',
      manual: false,
      bannerList: [{
        //   id: 'banner_movecar',
        //   name: '码上挪车',
        //   url: 'https://detail.tmall.com/item.htm?spm=a220m.1000858.1000725.21.67065fe12Hp3qY&id=568820639768&areaId=330100&user_id=3854958416&cat_id=2&is_b=1&rn=8dc3685735df4ec921fa3ad0ccb6f879',
        //   img: 'https://app.s4s.cn/h5vio/img/movecar_ad.jpg',
        // },
        // {
        //   id: 'banner_yqh',
        //   name: '有钱花',
        //   url: 'https://jin.baidu.com/mkt/cloan/guide?code=0122huoke01&channel=JXJhuoke&spot=qichedasheng-201808219',
        //   img: 'https://app.s4s.cn/h5vio/img/baidu_yqh.png',
        // },
        // {
        id: 'renbaojiaxian',
        name: '驾乘意外保险',
        url: '',
        img: 'https://app.s4s.cn/h5vio/img/renbaojiaxian.jpg',
      },
      ],
      // 资讯
      data: [],
      page: 1,
      loading: false,
      search: false,
      includedComponents: 'illegal',
      provice: '浙',
      showProvice: false,
      helpImageSrc: '',
      user: null,
      carno: '',
      engion: '',
      vin: '',
      car: null,
      engineNoLength: 0,
      vinLength: 0,
      vinPlaceholder: '请输入完整的车架号',
      enginePlaceholder: '请输入完整的发动机号',
      current: 0,
      showSelectedItem: false,
      selectedItem: {},
      illegal: {},
      records: [],
      error: '',
      isCarnoTrue: true,
      isVinTrue: true,
      isEngineTrue: true,
      showCaptcha: false,
      needCaptcha: false,
      captchUrl: '',
      captchKey: '',
      captchValue: ['', '', '', ''],
      captchKeyArray: [[1, 2, 3], [4, 5, 6], [7, 8, 9]],
      picker: {
        // anchor: [],
        data: [
          { value: '小型轿车', id: '02' },
          { value: '大型汽车', id: '01' },
          { value: '中国香港入境车', id: '26' },
          { value: '中国澳门入境车', id: '27' },
          { value: '新能源大车', id: '51' },
          { value: '新能源小车', id: '52' }],
        // anchor:'',
        textConfirm: '确认',
        textCancel: '取消',
        swipeTime: 1800,
        colorConfirm: '#3A82FF',
        colorTitle: '',
      },
      carType: { value: '小型轿车', id: '02' },
      hidden: false,

      DzyNotice: null,
      advertisingShow: advertisingShow(),
      opacity: 1,
      disabled: false,
      illegalError: false,

    };
  },
  computed: {
    carList() {
      return this.$store.getters.carList;
    },
  },
  watch: {
    carList() {
      this.current = 0;
      if (this.carList[this.current] && this.carList[this.current].proviceCarno) {
        this.getIllegal({ ...this.carList[this.current] });
      }
    },
    provice(val) {
      this.getRule(val);
    },
  },
  deactivated() {
    this.hidden = true;
  },
  activated() {
    this.hidden = false;
    if (this.$route.query && this.$route.query.redirect === '/') {
      // 登录完成后
      this.manual = true;
      this.provice = this.$route.query.proviceCarno.substring(0, 1);
      this.carno = this.$route.query.proviceCarno.substring(1);
      this.engion = this.$route.query.engion;
      this.vin = this.$route.query.vin;
      // this.formSubmit();
    } else if (this.carno && this.current !== 0 && this.current !== this.carList.length) {
      this.manual = true;
      this.getIllegal({
        proviceCarno: this.provice + this.carno,
        vin: this.vin,
        engion: this.engion,
        carType: this.carType && this.carType.id,
      });
    } else {
      this.getIllegal({ ...this.carList[this.current] });
    }
    if (!this.$store.getters.carList.length) {
      this.$store.dispatch('getCar').then((res) => {

      });
    }
  },
  created() {
    // if(!(this.carList.length == 0 && !this.$route.query.carno) && this.advertisingShow=='cmbchange'){
    //     this.$router.push('/ticket');
    // }
  },
  mounted() {
    const nowChannel = this.$route.query.channel || window.localStorage.getItem('viochannel') || window.localStorage.getItem('advertising');
    // _czc.push(['_trackEvent', 'page', 'llegal', nowChannel + '','1','']); //eslint-disable-line
    if (nowChannel == 'xcarillegal' || nowChannel == 'xcarticket') {
      this.$store.commit('SET_CARLIST', []); // 切换用户后把车辆列表置空
    }
    document.getElementById('title').innerHTML = '违章查询';
    this.getAdUrl();
    this.hidden = false;

    const s4s = document.getElementById('s4s');
    s4s.addEventListener('scroll', () => {
      if (s4s.scrollHeight - s4s.scrollTop <= s4s.clientHeight + 300 && !this.loading) {
        this.load(this.page + 1);
      }
    });
    this.load(this.page, true);

    this.getNotice();

    if (this.$route.query.channel) {
      try {
        window.localStorage.viochannel = this.$route.query.channel || '';
      } catch (e) {
        console.log(e);
      }
    }
    if (this.$route.query && this.$route.query.redirect === '/') {
      // 登录完成后
      this.manual = true;
      this.provice = this.$route.query.proviceCarno &&
          this.$route.query.proviceCarno.substring(0, 1) || '浙';
      this.carno = this.$route.query.proviceCarno &&
          this.$route.query.proviceCarno.substring(1);
      this.engion = this.$route.query.engion;
      this.vin = this.$route.query.vin;
      const carType = this.$route.query.car_type || this.$route.query.carType || '';
      for (let i = 0; i < this.picker.data.length; i += 1) {
        if (carType === this.picker.data[i].id) {
          this.carType = this.picker.data[i];
        }
      }
      // this.formSubmit();
    } else if (this.$route.query.carno) {
      this.manual = true;
      const queryCarno = this.$route.query.carno
        ? this.$route.query.carno
        : '';
      if (queryCarno.substring(0, 1)) {
        this.provice = queryCarno.substring(0, 1);
      }
      this.carno = queryCarno.substring(1);

      this.engion = this.$route.query.engine
        ? this.$route.query.engine
        : '';
      this.vin = this.$route.query.vin
        ? this.$route.query.vin
        : '';
      const carType = this.$route.query.car_type
        ? this.$route.query.car_type
        : '';

      for (let i = 0; i < this.picker.data.length; i += 1) {
        if (carType === this.picker.data[i].id) {
          this.carType = this.picker.data[i];
        }
      }
      this.$store.commit('SET_CHANNEL', this.$route.query.carno);
      let breakAdd = true;
      this.$store.getters.carList.forEach((item) => {
        if (queryCarno == item.proviceCarno) {
          breakAdd = false;
        }
      });
      if (breakAdd) {
        return;
      }
      // this.getIllegal({
      //   proviceCarno: this.provice + this.carno,
      //   vin: this.vin,
      //   engion: this.engion,
      //   carType: this.carType && this.carType.id,
      // });
      // return;
    }
    // else if (this.carList.length) {
    //   console.log('-----------elseif')
    //   this.getIllegal({ ...this.carList[this.current] });
    // }

    this.getRule(this.provice);
    // this.getCar();
    this.$store.dispatch('getCar').then((res) => {
      console.log(res);
      this.manual = false;
      // if (this.carList.length && this.$route.query.redirect !== '/') {
      //   console.log(this.$route.query.redirect !== '/');
      //   this.getIllegal({ ...this.carList[0] });
      // }
    });
  },
  methods: {
    // 选择日期
    dataChoose() {
      this.showPop = true;
    },
    // 选择日期的确认按钮
    confirms(value) {
      const date = value;
      const Y = `${date.getFullYear()}-`;
      let M = (date.getMonth() + 1);
      let D = `${date.getDate()} `;
      if (M < 10) {
        M = `0${M}`;
      }
      if (D < 10) {
        D = `0${D}`;
      }
      this.dataChange = `${Y + M}-${D}`;
      this.showPop = false;
    },
    // 选择日期的取消按钮
    cancels() {
      this.showPop = false;
    },
    // 点击手动输入
    handler() {
      this.manual = true;
    },
    getAdUrl() {
      this.$request('v5/renbao/link').then((xhr, res) => {
        if (res.code === 0 && res.data) {
          this.bannerList[0].url = res.data;
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    getNotice() {
      this.$request('v3/violation/view/notice').then((xhr, res) => {
        if (res.code === 0 && res.data) {
          if (res.data.DzyHave) {
            this.DzyNotice = res.data.DzyNotice;
          }
        } else {
          this.DzyNotice = null;
        }
      }).catch((e) => {
        console.log(e);
        this.DzyNotice = null;
      });
    },
    gotoMys4s() {
      // _czc.push(['_trackEvent', '齐车大圣', 'current=1', 'illegal', '', '']); //eslint-disable-line
      window.location.href = 'https://mys4s.cn/#/driver?current=1';
    },
    gotoMovecar() {
      // _czc.push(['_trackEvent', '点击挪车', '跳转', '', '', '']); //eslint-disable-line
      this.$refs.movecar.click();
    },
    gotoYQH() {
      // _czc.push(['_trackEvent', '点击有钱花', '跳转', '', '', '']); //eslint-disable-line
      this.$refs.baiduyqh.click();
    },
    load(page) {
      if (this.loading) {
        return;
      }
      this.started = true;
      this.loading = true;
      const params = {
        page_num: page || 1,
        list_id: 'illegal',
        address: 'vio:h5:news',
      };
      this.$request('v5/price/get_news_list', params).then((xhr, res) => {
        if (res.code === 0) {
          this.data = [...this.data, ...res.data];
          this.page = page;
        }
        this.loading = false;
      }).catch((e) => {
        console.log(e);
        this.loading = false;
      });
    },
    gotoNews({ id, Type, url }) {
      if (Type === 1) {
        window.open(`https://mys4s.cn/static/xcar/index.html#/News/${id}?token=${this.$store.getters.token}&xfrom=h5_vio`);
      } else if (Type === 2) {
        window.open(`https://mys4s.cn/h5/taro_valuation/index.html?token=${this.$store.getters.token}&xfrom=h5_vio`);
      } else if (Type === 3) {
        window.open(url);
      } else {
        window.open(url);
      }
    },
    checkLogin() {
      if (!this.$store.getters.userInfo || !this.$store.getters.token) {
        this.$router.push({
          path: '/login',
          query: {
            redirect: '/',
          },
        });
        return false;
      }
      return true;
    },
    uploadImage() {
      if (!this.checkLogin()) return;
      console.log(this.$refs);
      this.$refs.file.click();
    },
    fileChanged(e) {
      const self = this;
      const list = this.$refs.file.files;
      if (list.length !== 1) {
        this.$showToast({ title: '最多只能选择1张行驶证。' });
      }
      const item = {
        name: list[0].name,
        size: list[0].size,
        file: list[0],
      };
      self.html5Reader(list[0], item);
      e.target.value = '';
    },
    html5Reader(file, item) {
      const that = this;
      const imgSrc = new Image();
      const reader = new FileReader();
      reader.onload = (e) => {
        imgSrc.src = e.srcElement.result;
        that.$set(item, 'src', e.srcElement.result);
        imgSrc.onload = function () {//eslint-disable-line
          // 图片原始尺寸
          const originWidth = this.width;
          const originHeight = this.height;
          // 最大尺寸限制
          const maxWidth = 2000;
          const maxHeight = 2000;
          // 目标尺寸
          let targetWidth = originWidth;
          let targetHeight = originHeight;
          // 图片尺寸超过400x400的限制
          if (originWidth > maxWidth || originHeight > maxHeight) {
            if (originWidth / originHeight > maxWidth / maxHeight) {
              // 更宽，按照宽度限定尺寸
              targetWidth = maxWidth;
              targetHeight = Math.round(maxWidth * (originHeight / originWidth));
            } else {
              targetHeight = maxHeight;
              targetWidth = Math.round(maxHeight * (originWidth / originHeight));
            }
          }
          // 压缩的canvas
          const canvas = document.getElementById('canvas');
          const context = canvas.getContext('2d');

          canvas.width = targetWidth;
          canvas.height = targetHeight;

          // photoAnimate = new photoScan({
          //   imgSrc, visible: true, width: this.width, height: this.height,
          // });
          // photoAnimate.animate();
          // 清除画布
          context.clearRect(0, 0, targetWidth, targetHeight);
          // 图片压缩
          context.drawImage(imgSrc, 0, 0, targetWidth, targetHeight);


          // canvas转为blob并上传
          const data = canvas.toDataURL('image/jpeg').split(',')[1];
          // 获取base64图片大小，返回MB数字
          const size = parseInt(data.length - data.length / 8 * 2);//eslint-disable-line

          if (size) {
            const isLt2M = size / 1024 / 1024 < 2;
            if (!isLt2M) {
              photoAnimate.stopAnimation(() => {
                that.$showToast({ title: '图片大小需要小于 2MB!' });
              });
              return;
            }
            that.$showToast({title: '正在上传'});

            that.vehiclecardFetch(data);
          }
        };
      };
      reader.readAsDataURL(file);
    },
    vehiclecardFetch(data) {
      // 识别行驶证
      const self = this;
      this.$requestPost('v3/violation/driver/recognition', {
        imageString: data,
      })
        .then((xhr, res) => {
          // photoAnimate.stopAnimation(() => {
            if (res.code === 0) {
              if (res.data && res.data[0]) {
                this.$showToast({ title: '行驶证识别成功，请您核对信息是否准确' });
                this.manual = true;
                this.vehicleInfo(res.data[0]);
              } else {
                this.$showToast({ title: '行驶证图片识别失败，请再次拍照识别或手动输入' });
              }
            } else {
              this.$showToast({ title: res.msg });
            }
          // });
        })
        .catch(() => {
          // this.photoAnimate.stopAnimation(() => {
            this.$showToast({ title: '网络错误' });
          // });
        });
    },
    vehicleInfo(val) {
      // 匹配车辆信息
      this.car = val;
      this.provice = val.CarNo ? val.CarNo.substring(0, 1) : '浙';
      this.carno = val.CarNo ? val.CarNo.substring(1) : '';
      this.vin = val.Vin || '';
      this.engion = val.Engion || '';
      this.dataChange = val.RegisterDate || '';
      const carType = val.CarType;

      // 查找车辆类型 装填
      for (let i = 0; i < this.picker.data.length; i += 1) {
        if (carType === this.picker.data[i].value) {
          this.carType = this.picker.data[i];
        }
      }
    },
    onSwiperAdd() {
      this.$router.push({
        path: '/addcar',
        query: {
          redirect: '/',
        },
      });
    },
    hideDetailm() {
      this.showSelectedItem = false;
      this.selectedItem = {};
    },
    showDetail(item) {
      this.showSelectedItem = true;
      this.selectedItem = item;
    },
    gotoPay(item) {
      if (!this.$store.getters.userInfo) {
        this.$router.push({
          path: '/login',
          query: {
            redirect: '/',
          },
        });
        return;
      }
      if (this.showSelectedItem) {
        this.showSelectedItem = false;
        this.selectedItem = {};
      }
      let vin = '';
      let engion = '';
      for (let i = 0; i < this.carList.length; i += 1) {
        if (this.illegal.CarNo === this.carList[i].proviceCarno) {
          vin = this.carList[i].vin;//eslint-disable-line
          engion = this.carList[i].engion;//eslint-disable-line
        }
      }
      this.$store.commit('SET_ILLEGALPAYDATA', {
        ...item,
        CarNo: this.illegal.CarNo,
        vin,
        engion,
      });
      if (this.DzyNotice) {
        this.$showModal({
          title: this.DzyNotice.Title,
          content: this.DzyNotice.Content,
          confirmText: '我知道了',
          confirmFn: () => {
            this.$router.push({
              path: '/formWrap/illegalPay',
            });
          },
        });
      } else {
        this.$router.push({
          path: '/formWrap/illegalPay',
        });
      }
    },
    // 违章查询
    formSubmit() {
      const self = this;
      // if(this.advertisingShow=='cmbchange'){
      //   this.$router.push('/ticket');
      //   return;
      // }
      // 错误初始化
      self.clearError();
      const proviceCarno = self.carno ? (self.provice + self.carno) : '';
      const vin = self.vin || '';
      const engion = self.engion || '';
      const carType = self.carType.id || '';
      const dataChange = self.dataChange == '请选择日期' ? '' : self.dataChange;

      if (proviceCarno.length !== 7 && proviceCarno.length !== 8) {
        self.isCarnoTrue = false;
        self.error = '车牌号码错误，请输入正确的车牌号。';
        return;
      }
      if (self.vinLength > 0 && vin.length < 6) {
        self.isVinTrue = false;
        self.error = '车架号码错误，请输入正确的车架号。';
        return;
      }
      if (self.engineNoLength > 0 && engion.length < 6) {
        self.isEngineTrue = false;
        self.error = '发动机号码错误，请输入正确的发动机号码。';
        return;
      }
      if (self.dataChange == '请选择日期' || self.dataChange == '') {
        self.isEngineTrue = false;
        self.error = '请选择日期';
        return;
      }
      const param = {
        car_no: proviceCarno,
        vin,
        engine: engion,
        registe_time: dataChange,
        car_type: carType,
      };
      this.$store.commit('SET_SCOTT_CAR_PARAM', param);
      if (!this.$store.getters.userInfo || !this.$store.getters.token) {
        this.$router.push({
          path: '/login',
          query: {
            redirect: '/',
            proviceCarno,
            vin,
            engion,
            carType,
            dataChange,
          },
        });
        return;
      }
      // self.getIllegal({
      //   proviceCarno, vin, engion, carType,
      // });
      // const param = {
      //   car_no: proviceCarno,
      //   vin: vin,
      //   engine: engion,
      //   car_type: carType,
      //   registe_time: self.dataChange == "请选择日期" ? '' : self.dataChange
      // };
      this.carInfoSubmit(param);
    },
    // 获取验证码
    getCaptcha() {
      const that = this;
      that.$request('v3/captcha', {
        width: 180,
        height: 80,
        cap_len: 4,
        dot_count: 80,
        skew: 1,
      }).then((xhr, res) => {
        if (res.code === 0) {
          that.captchKey = res.data.key;
          that.captchUrl = res.data.image;
          that.captchValue = ['', '', '', ''];
        } else {
          setTimeout(() => {
            this.$showToast({
              icon: 'none',
              title: res.msg, // 文字内容
            });
          }, 0);
          that.captchValue = ['', '', '', ''];
        }
      }).catch(() => {
        that.$showToast({
          icon: 'none',
          title: '需要填写验证码.', // 文字内容
        });
        that.captchValue = ['', '', '', ''];
      });
    },
    // 输入验证码
    onInputCaptcha(value) {
      let arr = [...this.captchValue];
      let index = 3;
      if (value === '←') {
        const string = [...this.captchValue].join('');
        const newString = string.substring(0, string.length - 1);
        arr = [newString[0] || '', newString[1] || '', newString[2] || '', newString[3] || ''];
        this.captchValue = arr;

        return;
      }
      if (this.captchValue[3]) {
        return;
      }
      if (!this.captchValue[0]) {
        index = 0;
      } else if (!this.captchValue[1]) {
        index = 1;
      } else if (!this.captchValue[2]) {
        index = 2;
      } else if (!this.captchValue[3]) {
        index = 3;
      }
      arr[index] = value;

      // swan.showToast({
      //   title: arr
      // })
      this.captchValue = arr;
      if (arr[3]) {
        this.getIllegal({
          proviceCarno: this.provice + this.carno,
          vin: this.vin,
          engion: this.engion,
          carType: this.carType && this.carType.id,
        });
      }
    },
    // 查询结果
    getIllegal({
      proviceCarno, vin, engion, carType,
    }) {
      if (this.search || this.hidden) {
        return;
      }
      if (!proviceCarno) {
        this.records = [];
        this.illegal = {
          CarNo: '',
          Fine: 0,
          total: 0,
          degree: 0,
          fine: 0,
        };
        return;
      }
      const self = this;
      self.showCaptcha = false;
      const param = {
        // formid: '',
        car_no: proviceCarno ? proviceCarno.toUpperCase() : '',
        vin: vin ? vin.toUpperCase() : '',
        engine: engion ? engion.toUpperCase() : '',
        registe_time: self.dataChange == '请选择日期' ? '' : self.dataChange,
      };

      if (carType) {
        // 如果有车辆类型
        param.car_type = carType;
      }
      if (self.needCaptcha) {
        // 如果需要验证码
        param.key = self.captchKey;
        param.value = self.captchValue.join('');
      }
      self.$showLoading({
        title: '正在查询',
      });
      this.search = true;

      this.provice = proviceCarno.substring(0, 1);
      this.carno = proviceCarno.substring(1);
      this.engion = engion;
      this.vin = vin;
      for (let i = 0; i < this.picker.data.length; i += 1) {
        if (carType === this.picker.data[i].id) {
          this.carType = this.picker.data[i];
        }
      }
      // if (this.$route.query.carno) { // 链接上存在车牌号查询 就去添加到爱车列表
      //   this.$store.commit('SET_SCOTT_CAR_PARAM', param);
      //   //??/manage
      //   this.carInfoSubmit(param)

      //   const carList = [{
      //     proviceCarno: param.car_no || '',
      //     vin: param.vin || '',
      //     engion: param.engine || '',
      //     carType: param.car_type || '',
      //   }];
      //   self.$store.commit('SET_CARLIST', carList.reverse());
      // }
      if (!this.$store.getters.userInfo || !this.$store.getters.token) {
        this.$router.push({
          path: '/login',
          query: {
            redirect: '/',
            proviceCarno,
            vin,
            engion,
            carType,
          },
        });
        return;
      }
      self.$requestPost('v3/violation/web/query', param).then((xhr, res) => {
        self.$hideLoading();
        // res.code = 90027;
        this.search = false;
        if (res.code === 90027) {
          // 需要验证码 90027
          this.showCaptcha = true;
          this.needCaptcha = true;
          this.provice = param.car_no.substring(0, 1);
          this.carno = param.car_no.substring(1);
          this.vin = param.vin;
          this.engion = param.engine;
          self.$showToast({
            icon: 'none',
            title: '需要填写验证码',
          });
          self.getCaptcha(param);
        } else if (res.code !== 0) {
          let illegalErrorMsg = '';
          if (res.code >= 90015 && res.code <= 90019) {
            this.illegalError = true;
            illegalErrorMsg = '非常抱歉，您输入的车辆信息有误';
          } else {
            this.illegalError = false;
          }
          this.records = [];
          this.illegal = {
            CarNo: '',
            Fine: 0,
            total: 0,
            degree: 0,
            fine: 0,
          };
          self.$showToast({
            icon: 'none',
            title: illegalErrorMsg || res.msg,
          });
        } else if (res.code === 0 && res.data) {
          // self.carInfoSubmit(param);
          this.records = res.data.Records || [];
          this.illegal = {
            CarNo: param.car_no,
            Fine: res.data.Fine,
            total: res.data.Total || 0,
            degree: res.data.Degree || 0,
            fine: res.data.Fine || 0,
          };
          this.showCaptcha = false;
          this.needCaptcha = false;
          if (this.current === this.carList.length && !this.$route.query.carno) {
            this.records = [];
          }
        }
      }).catch((e) => {
        this.search = false;

        console.log(e);
        self.$hideLoading();
      });
    },
    clearError() {
      // 错误初始化
      this.isCarnoTrue = true;
      this.isVinTrue = true;
      this.isEngineTrue = true;
      this.error = '';
    },
    getRule(val) {
      this.$request('v3/violation/rule', {
        prefix: val,
      }).then((xhr, res) => {
        if (res.code === 20022) {
          return;
        }
        if (res.code >= 40000 && res.code < 50000) {
          return;
        }
        if (res.code === 0) {
          this.vinLength = res.data.vinLength;
          this.engineNoLength = res.data.engineNoLength;
          // if (res.data.vinLength > 0) {
          //   this.vinPlaceholder = res.data.vinLength === 99 ? '请输入完整的车架号' : `请输入车架号后${res.data.vinLength}位`;
          // }
          // if (res.data.engineNoLength > 0) {
          //   this.enginePlaceholder = res.data.engineNoLength === 99 ? '请输入完整的发动机号' : `请输入发动机号后${res.data.engineNoLength}位`;
          // }
        }
      });
    },
    editcar(carinfo) {
      console.log(carinfo, '=+=');
      this.$router.push({
        name: 'addcar',
        query: { ...carinfo, redirect: '/' },
      });
      // console.log(...carinfo,'编辑车辆')
    },
    gotoTicket() {
      this.$router.push({
        path: '/ticket',
        query: {},
      });
    },
    // 添加爱车
    carInfoSubmit(carInfo) {
      this.manual = false;
      // let breakAdd = false
      // this.$store.getters.carList.forEach(item => {
      //   if (carInfo.car_no == item.proviceCarno) {
      //     breakAdd = true
      //   }
      // })
      // if (breakAdd) {
      //   return
      // }

      this.$request('v3/violation/car/manage', carInfo).then((xhrr, ress) => {
        if (ress.code === 0) {
          this.manual = false;
          this.getCar();
        }
        if (res.code >= 40000 && res.code < 50000) {
          this.$router.push({
            path: '/login',
            query: {
              redirect: '/',
            },
          });
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    // 获取我的爱车
    getCar() {
      if (!this.checkLogin()) return;
      const self = this;
      const getCarPromise = new Promise((getCarResolve) => {
        self.$request('v3/violation/car/list').then((xhr, res) => {
          this.manual = false;
          if (res.code === 0) {
            if (res.data == null) {
              self.carno = '';
              self.provice = '京';
              self.vin = '';
              self.engion = '';
              self.$store.commit('SET_CARLIST', []);
            }
            if (res.data && res.data.length > 0) {
              self.carno = res.data[0].CarNo.substring(1) || '';
              self.provice = res.data[0].CarNo.substring(0, 1) || '京';
              self.vin = res.data[0].ClassNo || '';
              self.engion = res.data[0].EngineNo || '';
              self.current = 0;
              const carType = res.data[0].CarType || '02';

              this.getIllegal({
                proviceCarno: res.data[0].CarNo,
                vin: res.data[0].ClassNo,
                engion: res.data[0].EngineNo,
                carType,
              });
              for (let i = 0; i < self.picker.data.length; i += 1) {
                if (carType === self.picker.data[i].id) {
                  self.carType = self.picker.data[i];
                }
              }
              const carList = res.data.map(item => ({
                proviceCarno: item.CarNo || '',
                // provice: item.CarNo.substring(0, 1) || '京',
                vin: item.ClassNo || '',
                engion: item.EngineNo || '',
                carType: item.CarType,
                registe_time: item.RegisterCardTime || '',
              }));
              self.$store.commit('SET_CARLIST', carList);
            }
            // self.getIllegal();
          } else {
            self.$store.commit('SET_CARLIST', []);
          }
          getCarResolve('true');
        }).catch((e) => {
          console.log(e);
        });
      });
      return getCarPromise;
    },
    handlePickerCancel() {
    },
    handlePickerConfirm(e) {
      const [first] = e;
      this.carType = this.picker.data[first.index];
      // this.form.time = e[0].value + "-" + e[1].value + "-" + e[2].value;
    },
    selectCarType() {
      this.showProvice = false;
      this.$refs.picker.show();
    },
    selectProvice() {
      console.log('选择日期');
      this.showProvice = !this.showProvice;
    },
    onProviceStatusChange(val) {
      this.showProvice = val;
    },
    onProviceResultChange(val) {
      const arr = ['晋', '黑', '云', '甘', '藏', '警', '学', '港', '澳', '使'];
      this.provice = val;
      if (arr.indexOf(val) != -1) {
        this.$showToast({ title: '暂不支持查询' });
        this.disabled = true;
        this.opacity = 0.5;
        return;
      }
      this.disabled = false;
      this.opacity = 1;
    },
    onSwiperChange(index) {
      this.current = index;

      this.getIllegal({ ...this.carList[index] });
    },
    // 关闭蒙层
    hideImage() {
      this.helpImageSrc = '';
    },
    // 发动机详情
    showImage(src) {
      this.helpImageSrc = src;
    },

  },
};
</script>
<style lang="scss" scoped>
input {
  text-transform: uppercase;
}

.s4s-page {
  height: 100%;
  padding: 0 !important;
  box-sizing: border-box;
  // overflow-y: scroll;
  // overflow-x: hidden;
  // min-height: 600px;
}

.scroll-page {
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
  padding-bottom: 60px;
}

.s4s-illegal-bg {
  background: #00a1ee url(../assets/icon/head_bg.png) no-repeat left bottom / 100% 28px;
  width: 100%;
  height: 110px;
}

.s4s-form-title {
  display: flex;
  align-items: center;

}

.s4s-illegal-bd-txt {
  width: auto;
  padding-top: 0;
}

.s4s-title-icon {
  background-image: linear-gradient(132deg, #95A8FF 0%, #565DFC 100%);
  border-radius: 0 10px 10px 10px;
  font-size: 11px;
  color: #fff;
  padding: 4px 8px;
}

.s4s-title-icon1 {
  // font-size:11px;
  // color:#fff;
  // border-radius: 2px;
  // display:inline-block;
  // padding:0 5px;
  // border-radius: 20px;
  // color: #3A82FF;
  // border: .5px solid #3A82FF;
  // padding: 4px 8px;
  //  margin-left:10px;
  // color: #FFAF30;
  // border-color: #FFAF30;
  border-radius: 0 10px 10px 10px;
  font-size: 11px;
  color: #fff;
  padding: 4px 8px;
  margin-left: 10px;
  background-image: linear-gradient(140deg, #FFC63D 0%, #FFA55F 100%);
  border-radius: 0 10px 10px 10px;
}

.s4s-index-pic {
  width: 80px;
  height: 50px;
}


.s4s-tit-hd {
  display: flex;
}

.s4s-right {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.s4s-right-txt {
  font-size: 13px;
  color: #aaa;
  display: block;
}

.s4s-illegal-btn {
  position: absolute;
  right: 12px;
  bottom: 10px;
  border-top: 1px rgba(0, 0, 0, 0.05) solid;
  padding: 5px 018px;
  border-radius: 2px;
  background-image: linear-gradient(-151deg, #105FF8 0%, #537EFF 100%);
  box-shadow: 1px 1px 3px 0 #D2D2D2;
  font-size: 14px;
  color: #fff;
  line-height: 20px;
  display: flex;
  align-items: center;
}

/*
* author: ernest
* alter content: 车辆轮播
*/
.swiper {
  height: 125px;
  /* transform: scale(0.9); */
  overflow: visible;
  width: 97%;
  margin: 0 auto;
  margin-bottom: 10px;
}

.swiper-item {
  border-radius: 2px;
  /* width: 80%!important; */
  /* margin-right: 10px; */
}

.s4s-illegal-empty {
  color: #AAAAAA;
  font-size: 14px;
  margin-top: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.s4s-selected {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.s4s-selected-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  font-size: 12px;
  background: #fff;
  border-radius: 2px;
  z-index: 200;
  width: calc(100% - 40px);
}

.s4s-selected-btn-container {
  display: flex;
}

.s4s-selected-btn {
  flex: 1;
  font-size: 12px;
  text-align: center;
  line-height: 21px;
  padding: 11px 0;
}

.s4s-selected-btn:nth-child(2) {
  color: #fff;
  background-image: linear-gradient(-151deg, #105FF8 0%, #537EFF 100%);
}

.s4s-selected-btn:first-child {
  color: #5b5e6a;
  border-top: .5px solid #eaeaea;
  background-color: #fff;
}

.captcha {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;

}

.captcha .s4s-mask {
  z-index: 1;
}

.captcha-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  background-color: #fff;
  padding: 12px;
  border-radius: 5px;
  padding-bottom: 0;
  z-index: 1;
  width: 75%;
  text-align: center;
}

.captcha-title {
  color: #333333;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
}

.captcha-input:focus, .captcha-input {
  outline: none;
}

.captcha-input-container {
  width: 100%;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.captcha-input-list {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.captcha-change {
  color: #6F6F6F;
  font-size: 12px;
  margin-bottom: 12.5px;
  text-align: center;
}

.captcha-input {
  min-height: 40px;
  line-height: 40px;
  font-size: 22px;
  color: #333;
  flex: 1;
  width: 40px;
  border: 1px solid #eaeaea;
  margin-right: 10px;
  max-width: 40px;
  text-align: center;
}

.captcha-input:last-child {
  margin-right: 0;
}

.captcha-btn {
  width: 100%;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  background-image: linear-gradient(40deg, #FF7C00 0%, #FE5A00 100%);
  border-radius: 5px;
  color: #fff;
}

.captcha-keyboard {
  /* display: flex; */
  /* justify-content: space-around; */
  /* flex-wrap: wrap; */
  margin-top: 25px;
}

.captcha-key-list {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}

.captcha-key {
  border: none;
  text-align: center;
  color: #24252D;
  font-size: 24px;
  width: 80px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
}

.s4s-btn {
  display: block;
  width: 100%;
  margin: 50px 0 12px;
}

.data {
  color: #24252d !important;
}

.ai_content {
  background: #fff;
  margin-top: 20 rpx;
  padding: 10px 15px 15px 15px;

}

.ai_text {
  display: block;
  font-size: 20px;
  font-weight: bold;
  color: #24252D;
  line-height: 20px;
  /* vertical-align: top; */
}

.ai_img {
  display: block;

}

.illegal-error {
  font-size: 14px;
  margin: 10px 32px;
  line-height: 1.4;
}

.ticket-btn1 {
  background: #fff;
  border: 1px solid #EAEAEA;
  color: #24252D;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 289px;
  height: 40px;
  line-height: 40 xp;
  font-size: 14px;
  border-radius: 20px !important;
}

.s4s-right-arr {
  height: 14px;
  width: 7px;
  margin-left: 10px;
}
</style>
